import InputGroup from './InputGroup'
import UiDropdown from './UiDropdown'
import UiPreview from './UiPreview'
import AccordionUi from './AccordionUi'
import AccordionUiDef from './AccordionUiDef'
import AccordionUiLower from './AccordionUiLower'
import UiClickOutside from './UiClickOutside'
import OutsideUi from './OutsideUi'
import OutsideUiLower from './OutsideUiLower'
import HeaderMenuCommon from './HeaderMenuCommon'
import ReadMore from './ReadMore'
import ReadMoreReviews from './ReadMoreReviews'
import ModalTrigger from './ModalTrigger'
import ElSocialTool from './ElSocialTool'
import UiCaptcha from './UiCaptcha'
import UiRecaptcha from './UiRecaptcha'
// import PlacesCards from './PlacesCards'
// import MessageModal from './MessageModal'

export default function Components(Vue) {
  Vue.component('UiRecaptcha', UiRecaptcha)
  Vue.component('UiCaptcha', UiCaptcha)
  Vue.component('ElSocialTool', ElSocialTool)
  Vue.component('HeaderMenuCommon', HeaderMenuCommon)
  Vue.component('UiDropdown', UiDropdown)
  Vue.component('InputGroup', InputGroup)
  Vue.component('AccordionUiLower', AccordionUiLower)
  Vue.component('AccordionUiDef', AccordionUiDef)
  Vue.component('AccordionUi', AccordionUi)
  Vue.component('UiClickOutside', UiClickOutside)
  Vue.component('ReadMore', ReadMore)
  Vue.component('ReadMoreReviews', ReadMoreReviews)
  Vue.component('OutsideUi', OutsideUi)
  Vue.component('OutsideUiLower', OutsideUiLower)
  Vue.component('UiPreview', UiPreview)
  Vue.component('ModalTrigger', ModalTrigger)
  // Vue.component('PlacesCards', PlacesCards)
  // Vue.component('MessageModal', MessageModal)
}



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/index.js